import { render, staticRenderFns } from "./simplifyAcceptanceList.vue?vue&type=template&id=f6db524e&scoped=true"
import script from "./simplifyAcceptanceList.vue?vue&type=script&lang=js"
export * from "./simplifyAcceptanceList.vue?vue&type=script&lang=js"
import style0 from "./simplifyAcceptanceList.vue?vue&type=style&index=0&id=f6db524e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6db524e",
  null
  
)

export default component.exports